import React, {FC, useState}  from 'react';
import { PaymentsType } from '../../ReportsARBook/types';
import MenuItem from '@material-ui/core/MenuItem';
import { StyledFilterSelectFormControl, StyledFilterSelectList } from '../Style/Style';
interface FiltersSelectProps {
    fieldsData: PaymentsType[];
    handleSetFilter: (value: PaymentsType['value']) => void;
};

export const FiltersSelect: FC<FiltersSelectProps> = ({ fieldsData, handleSetFilter }) => {
  const [field, setField] = useState<PaymentsType['value']>(null);

  const handleChange = (event) => {
    const { value } = event.target;
    setField( value as string);
    handleSetFilter( value as string);
  };

  return (
    <StyledFilterSelectFormControl>
        <StyledFilterSelectList
          value={field}
          onChange={handleChange}
          displayEmpty
        >
        {fieldsData.map(({ name, value }) => <MenuItem value={value} key={name}>{name}</MenuItem>)}
      </StyledFilterSelectList>
    </StyledFilterSelectFormControl>
  )
};
